export default function ContactCard({ icon: Icon, iconBg, title, detail, action }) {
    return (
        <div className="bg-white border border-gray-100 rounded-2xl p-5 flex items-center gap-4">
            <div className={`w-11 h-11 rounded-xl flex items-center justify-center shrink-0 bg-gradient-to-br ${iconBg}`}>
                <Icon className="w-5 h-5 text-white" />
            </div>
            <div className="flex-1 min-w-0">
                <p className="font-semibold text-gray-900 text-sm">{title}</p>
                <p className="text-sm text-gray-500 truncate">{detail}</p>
            </div>
            {action}
        </div>
    );
}